<template>
    <Head title="Senha" />
    <RegisterLayout title="Senha">
        <article>
            <div class="sm:px-5 xl:max-w-[350px]">
                <!-- <HeadingGuest title="Senha" /> -->
                <p class="pb-4">Crie uma <strong>senha</strong> forte que só você saiba. Ela precisa ter:</p>

                <ul>
                    <li class="flex items-center pb-1">
                        <Icon :name="isValid(hasTenChar)"/>
                        <p class="ml-2.5 sm:text-sm">Mínimo de 10 caracteres</p>
                    </li>

                    <li class="flex items-center pb-1">
                        <Icon :name="isValid(hasUpperCase)" />
                        <p class="ml-2.5 sm:text-sm">Um caractere maiúsculo</p>
                    </li>

                    <li class="flex items-center pb-1">
                        <Icon :name="isValid(hasLowerCase)" />
                        <p class="ml-2.5 sm:text-sm">Um caractere minúsculo</p>
                    </li>

                    <li class="flex items-center pb-1">
                        <Icon :name="isValid(hasNumber)" />
                        <p class="ml-2.5 sm:text-sm">Um número</p>
                    </li>

                    <li class="flex items-center">
                        <Icon :name="isValid(hasSpecialChar)" />
                        <p class="ml-2.5 sm:text-sm">Um caractere especial (ex.: !@#$%)</p>
                    </li>
                </ul>


                <form @submit.prevent="submit" class="mb-6">
                    <ul class="pt-6">
                        <li class="mb-4">
                            <label class="mr-5 flex font-bold pb-1">Senha</label>
                            <Input
                                placeholder="*********"
                                :state="inputState"
                                id="password"
                                v-model="form.password"
                                type="password"
                                required
                                autofocus
                            />
                            <p class="text-[10px]">
                                Força da senha:
                                <span :class="powerPassword.classes">{{ powerPassword.text }}</span>
                            </p>
                        </li>

                        <li class="mb-8">
                            <label class="mr-5 flex font-bold pb-1">Confirme sua senha</label>
                            <Input
                                placeholder="*********"
                                id="confirmPassword"
                                :state="isEqualInputState"
                                v-model="confirmPassword"
                                type="password"
                                required
                                autofocus
                            />
                            <p v-if="!isEqual" class="text-[10px] text-error">Senhas não coincidem</p>
                            <p v-if="isEqual" class="text-[10px]">
                                Força da senha:
                                <span :class="powerPassword.classes">{{ powerPassword.text }}</span>
                            </p>
                        </li>

                        <li>
                            <Button
                                :enabled="allIsValid && isEqual"
                                >
                                    Cria Senha
                            </Button>
                        </li>
                    </ul>
                </form>
                <div v-if="$page.props.flash.error">
                    {{ $page.props.flash.error }}
                </div>

                <div v-if="$page.props.flash.success">
                    {{ $page.props.flash.success }}
                </div>
            </div>

        </article>
    </RegisterLayout>
</template>

<script>
import Input from '@/Components/UI/Form/Input.vue';
import Button from '@/Components/Button.vue';
import Icon from '@/Components/UI/Icons/Icon.vue'
import RegisterLayout from "@/Layouts/Register.vue";
import Header from '@/Components/UI/Nav/Header.vue'
import Back from '@/Components/UI/Back.vue'
import { Head, Link } from "@inertiajs/inertia-vue3";
import HeadingGuest from "@/Components/UI/Texts/HeadingGuest.vue"

export default {
    components: {
        Header,
        Head,
        Input,
        Button,
        Icon,
        Link,
        Back,
        RegisterLayout,
        HeadingGuest
    },
    data() {
        return {
            showModal: true,
            confirmPassword: '',
            form: this.$inertia.form({
                cpf: sessionStorage.getItem('cpf'),
                name: sessionStorage.getItem('name'),
                email: sessionStorage.getItem('email'),
                dob: sessionStorage.getItem('birthDate'),
                instagram: sessionStorage.getItem('instagram'),
                mobile: sessionStorage.getItem('mobile'),
                nickname: sessionStorage.getItem('nickname'),
                acceptRegulamento: sessionStorage.getItem('cpf'),
                acceptTerm: sessionStorage.getItem('cpf'),
                zipCode: sessionStorage.getItem('zipCode'),
                address: sessionStorage.getItem('address'),
                number: sessionStorage.getItem('number'),
                complement: sessionStorage.getItem('complement'),
                district: sessionStorage.getItem('district'),
                city: sessionStorage.getItem('city'),
                state: sessionStorage.getItem('state'),
                acceptRegulamento: '',
                acceptTerm: '',
                acceptPrivacy: '',
                password: '',
            })
        }
    },
    methods: {
        submit() {
            if(this.allIsValid && this.isEqual){
                sessionStorage.setItem('password', this.form.password);

                this.form.acceptRegulamento = JSON.parse(sessionStorage.getItem('acceptRegulamento'));
                this.form.acceptTerm = JSON.parse(sessionStorage.getItem('acceptTerm'));
                this.form.acceptPrivacy = JSON.parse(sessionStorage.getItem('acceptPrivacy'));

                this.$inertia.post('store', this.form);
            }
        },

        isValid(fn) {
            if(fn) {
                return 'Sucesso'
            } else {
                return 'Erro'
            }
        },
    },
    computed: {
        hasTenChar() {
            return this.form.password.length > 9;
        },
        hasUpperCase() {
            var re = /([A-Z])/g
            return re.test(this.form.password);
        },
        hasLowerCase() {
            var re = /([a-z])/g
            return re.test(this.form.password);
        },
        hasNumber() {
            var re = /([0-9])/g
            return re.test(this.form.password);
        },
        hasSpecialChar() {
            var re = /[^A-Za-z0-9]/
            return re.test(this.form.password);
        },
        isEqual() {
            return this.form.password === this.confirmPassword;
        },
        allIsValid() {
            return (this.hasTenChar && this.hasUpperCase && this.hasLowerCase && this.hasNumber && this.hasSpecialChar)
        },
        inputState() {
            if(this.form.password) {
                if(this.allIsValid) {
                    return 'success'
                } else {
                    return 'error'
                }
            }
        },
        isEqualInputState() {
            if(this.form.password) {
                if(this.isEqual) {
                    return 'success'
                } else {
                    return 'error'
                }
            }
        },
        powerPassword() {
            if(this.allIsValid) {
                return {
                classes: 'text-success',
                text: 'forte'
                }
            }
            else if(this.hasTenChar) {
                return {
                    classes: 'text-yellow-300',
                    text: 'média'
                }
            }
            else {
                return {
                    classes: 'text-error',
                    text: 'fraca'
                }
            }
        }
    }
}
</script>
